import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CustomerDto } from "src/app/shared/models/DTO/customer-dto";

@Component({
	selector: "app-about-me-detail",
	templateUrl: "./about-me-detail.component.html",
	styleUrls: ["../../customer.scss"],
})
export class AboutMeDetailComponent implements OnInit {
	@Input() customerKey: string;
	@Output() customerKeyChange = new EventEmitter<string>();
	customer: CustomerDto;

	constructor(public app: AppService, private focuslink: FocuslinkService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.app.loading(false);

		if (this.customerKey) {
			console.log(`loading customer ${this.customerKey}`);
			this.customerService.initPublicCustomer(this.customerKey);
		}
	}

	onSignOut() {
		this.customerKeyChange.emit(undefined);
	}
}
